import React from 'react';
import { CurrentRoundTotalOdds } from '../../components/currentRoundTotalOdds';
import { GameContentInner } from '../gameContentInner';

export const GameContent = () => {
  return (
    <div className='gameCenterHolder'>
      <CurrentRoundTotalOdds />
      <GameContentInner />
    </div>
  );
};
